<div class="rating-container" [class.show]="showRating">
  <div class="rating-card">
    <button mat-icon-button class="close-button" (click)="closeRating()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="rating-content">
      <h3>{{ 'rating.evaluationDmAnalytics' | translate}}</h3>
      <div class="rating-buttons">
        <button mat-button 
                *ngFor="let value of ratings" 
                (click)="selectRating(value)"
                [class.selected]="rating === value"
                [attr.aria-label]="'Avaliar com ' + value">
          {{value}}
        </button>
      </div>
    </div>

    <div class="feedback-content" *ngIf="showFeedback">
      <p>{{ 'rating.describeYourExperience' | translate}}</p>
      <textarea 
        class="feedback-textarea"
        [(ngModel)]="feedback"
        [placeholder]="'rating.feedbackPlaceholder' | translate"
        rows="4"
        maxlength="500">
      </textarea>
      <div class="feedback-actions">
        <button mat-button (click)="closeRating()" [disabled]="isSubmitting">{{ 'rating.cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="submitFeedback()" [disabled]="isSubmitting">
          <ng-container *ngIf="isSubmitting">{{ 'rating.submitting' | translate}}</ng-container>
          <ng-container *ngIf="!isSubmitting">{{ 'rating.submit' | translate}}</ng-container>
        </button>
        <!-- Debug: {{ isSubmitting ? 'ENVIANDO' : 'NORMAL' }} -->
      </div>
    </div>
  </div>
</div>


